import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RewardsActions } from '../actions/reward.action';
import { RewardsService } from '../../services/reward.service';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class RewardsEffects {
  private actions$ = inject(Actions);
  private api = inject(RewardsService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.loadRewards),
      switchMap(({ profileId, categoryId }) =>
        this.api.fetchRewards(profileId, categoryId).pipe(
          map((data) => RewardsActions.loadRewardsSuccess({ data })),
          catchError((err) =>
            of(RewardsActions.loadRewardsFailure({ error: err?.message ?? 'Failed to load rewards' }))
          )
        )
      )
    )
  );

  loadNotLoggedInRewards$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.loadNotLoggedRewards),
      switchMap(({ categoryId }) =>
        this.api.fetchNotLogedUserRewards(categoryId).pipe(
          map((data) => RewardsActions.loadNotLoggedSuccess({ data })),
          catchError((err) =>
            of(RewardsActions.loadNotLoggedFailure({ error: err?.message ?? 'Failed to load rewards' }))
          )
        )
      )
    )
  );

  claimReward$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.claimReward),
      switchMap(({ profileId, rewardIds }) =>
        this.api.rewardsClaim(profileId, rewardIds).pipe(
          map((res) => RewardsActions.claimRewardSuccess()),
          catchError((err) =>
            of(RewardsActions.claimRewardFailure({ error: err?.message ?? 'Failed to claim reward' }))
          )
        )
      )
    )
  );

  claimAllPerks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.claimAllPerks),
      switchMap(() =>
        this.api.fetchAllPerks().pipe(
          map((res) => RewardsActions.claimAllPerksSuccess({ data: res.perks })),
          catchError((err) =>
            of(RewardsActions.claimAllPerksFailure({ error: err?.message ?? 'Failed to claim reward' }))
          )
        )
      )
    )
  );

  fetchProfilesPerks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.fetchProfilesPerks),
      switchMap(({ profileIds }) =>
        this.api.fetchProfilesPerks(profileIds).pipe(
          map((data) => RewardsActions.fetchProfilesPerksSuccess({ data })),
          catchError((err) =>
            of(RewardsActions.fetchProfilesPerksFailure({ error: err?.message ?? 'Failed to fetch perks' }))
          )
        )
      )
    )
  );

  fetchCurrentProfilePerks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RewardsActions.fetchCurrentProfilePerks),
      switchMap(({ profileId }) =>
        this.api.fetchCurrentProfilePerks(profileId).pipe(
          map((data) => RewardsActions.fetchCurrentProfilePerksSuccess({ data })),
          catchError((err) =>
            of(RewardsActions.fetchCurrentProfilePerksFailure({ error: err?.message ?? 'Failed to fetch perks' }))
          )
        )
      )
    )
  );

}
